<main class="diwali-offers-page">
  <section class="diwali-hero" aria-label="Diwali shopping festival">
    <div class="diwali-hero-content">
      <span class="diwali-eyebrow">THE FESTIVE SEASON IS HERE</span>
      <h1>Diwali Dhamaka Sale</h1>
      <p>
        Light up your celebrations with amazing deals on all your favourites.
      </p>
      <button type="button" (click)="discountProductList()">
        Explore festive offers <span aria-hidden="true">→</span>
      </button>
    </div>
    <div class="diwali-hero-art" aria-hidden="true">
      <span class="diwali-spark diwali-spark-one">✦</span>
      <span class="diwali-spark diwali-spark-two">✧</span>
      <span class="diwali-lamp">🪔</span>
      <span class="diwali-lamp diwali-lamp-small">🪔</span>
      <span class="diwali-spark diwali-spark-three">✦</span>
    </div>
    <span class="diwali-hero-decor diwali-decor-left" aria-hidden="true"
      >✦</span
    >
    <span class="diwali-hero-decor diwali-decor-right" aria-hidden="true"
      >✧</span
    >
  </section>

  <section class="px-6 py-8 min-h-[350px]">
    <h2 class="text-xl font-bold mb-5">
      Latest Drops
      <!-- <span
      class="flex underline cursor-pointer hover:text-[#79273a]"
       
    >

      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="spo h-7 w-7 mx-1 rounded-full"
        shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision"
        image-rendering="optimizeQuality"
        fill="white"
        fill-rule="evenodd"
        clip-rule="evenodd"
        viewBox="0 0 512 512"
      >
        <path
          fill-rule="nonzero"
          d="M0 256c0 70.68 28.66 134.7 74.98 181.02C121.3 483.34 185.32 512 256 512c70.69 0 134.7-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256c0-70.69-28.66-134.7-74.98-181.02C390.7 28.66 326.69 0 256 0 185.32 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256zm231.67-109.04L340.7 256 231.67 365.04l-40.52-40.51 68.51-68.52-68.52-68.52 40.53-40.53zM101.01 410.99c-39.66-39.66-64.2-94.47-64.2-154.99 0-60.53 24.54-115.33 64.2-154.99 39.66-39.66 94.47-64.2 154.99-64.2 60.53 0 115.33 24.54 154.99 64.2 39.66 39.66 64.2 94.46 64.2 154.99 0 60.53-24.54 115.33-64.2 154.99-39.66 39.66-94.46 64.2-154.99 64.2-60.52 0-115.33-24.54-154.99-64.2z"
        />
      </svg>
    </span> -->
    </h2>

    <div class="flex min-h-[292px] gap-5 overflow-x-auto pb-4 scrollbar-hide">
      <div
        *ngFor="let product of newArrivals | slice: 0 : 8"
        class="min-w-[220px] bg-white rounded-2xl shadow hover:shadow-lg transition relative"
      >
        <!-- Image -->
        <div class="bg-gray-50 rounded-t-2xl p-4">
          <img
            [src]="productImageUrl + product.images[0]"
            alt=""
            class="h-40 w-full object-contain mx-auto"
            (click)="arrivalDetails(product._id)"
          />
        </div>

        <!-- Content -->
        <div class="p-4">
          <h3 class="text-sm font-medium truncate">
            {{ product.productDetails.productName }}
          </h3>

          <!-- Price -->
          <div class="flex items-center gap-2 mt-2">
            <span class="text-lg font-bold text-green-700">
              ₹{{ product.priceInventoryShippingInfo.sellingPrice }}
            </span>

            <span
              *ngIf="product.priceInventoryShippingInfo.MRP"
              class="text-sm text-red-600 line-through"
            >
              ₹{{ product.priceInventoryShippingInfo.MRP }}
            </span>
          </div>

          <!-- (click)="addtocart(product._id)" [disabled]="isLoggedIn && !isServiceable"
              aria-label="Add {{ productDetails?.productDetails?.productName }} to cart" -->
          <!-- Add to cart -->
          <button
            class="mt-3 w-full rounded-lg bg-[#79273a] py-1.5 text-sm text-white transition hover:bg-[#641e30]"
            (click)="addToCartFromList(product)"
          >
            Add to Cart
          </button>
        </div>

        <!-- NEW badge -->
        <span
          class="absolute top-3 left-3 bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full"
        >
          NEW
        </span>
      </div>
    </div>
    <div lazyLoad (visible)="loadArrivals()" class="h-1 w-full"></div>
  </section>

  <div class="grid grid-cols-12 gap-4 p-4 items-stretch">
    <div
      class="col-span-12 md:col-span-4 border p-4 rounded-3xl bg-[peachpuff] flex flex-col h-full"
    >
      <h1 class="text-xl font-bold mx-3 my-5 flex justify-between">
        Sponsored
        <span
          class="flex underline cursor-pointer hover:text-[#79273a]"
          (click)="sponsoredProductList()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="spo h-7 w-7 mx-1 rounded-full"
            fill="white"
            viewBox="0 0 512 512"
          >
            <path
              d="M0 256c0 70.68 28.66 134.7 74.98 181.02C121.3 483.34 185.32 512 256 512c70.69 0 134.7-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256c0-70.69-28.66-134.7-74.98-181.02C390.7 28.66 326.69 0 256 0 185.32 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256zm231.67-109.04L340.7 256 231.67 365.04l-40.52-40.51 68.51-68.52-68.52-68.52 40.53-40.53zM101.01 410.99c-39.66-39.66-64.2-94.47-64.2-154.99 0-60.53 24.54-115.33 64.2-154.99 39.66-39.66 94.47-64.2 154.99-64.2 60.53 0 115.33 24.54 154.99 64.2 39.66 39.66 64.2 94.46 64.2 154.99 0 60.53-24.54 115.33-64.2 154.99-39.66 39.66-94.46 64.2-154.99 64.2-60.52 0-115.33-24.54-154.99-64.2z"
            />
          </svg>
        </span>
      </h1>
      <div class="grid grid-cols-2 gap-3 flex-grow">
        <div
          *ngFor="let item of sponsored"
          class="border p-2 rounded-xl shadow-sm hover:shadow-md transition bg-white h-fit"
        >
          <img
            [src]="productImageUrl + item?.images[0]"
            [alt]="item?.productDetails?.productName || 'Product image'"
            class="w-full h-28 object-contain rounded-md cursor-pointer"
            (click)="productDetails(item)"
          />
          <p
            class="text-center font-semibold text-gray-800 mt-2 line-clamp-2 text-sm cursor-pointer"
            (click)="productDetails(item)"
          >
            {{ item.productDetails?.productName }}
          </p>
          <div class="flex items-center gap-2 justify-center mt-2">
            <span
              class="px-3 py-1 bg-[#79273a] text-white rounded-full text-sm font-semibold shadow"
              >₹{{ item?.priceInventoryShippingInfo?.sellingPrice }}</span
            >
            <span class="text-green-700 font-bold text-sm"
              >{{
                ((item?.priceInventoryShippingInfo?.MRP -
                  item?.priceInventoryShippingInfo?.sellingPrice) /
                  item?.priceInventoryShippingInfo?.MRP) *
                  100 | number: "1.0-0"
              }}% OFF</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="col-span-12 md:col-span-4 h-full">
      <div class="diwali-promo-tile">
        <span class="diwali-promo-lamp" aria-hidden="true">🪔</span>
        <span class="diwali-promo-kicker">A LITTLE MORE JOY</span>
        <h2>Celebrate Diwali<br />with a little extra sparkle</h2>
        <p>Festive finds and wonderful deals, all in one place.</p>
        <button type="button" (click)="discountProductList()">
          Shop Diwali deals
        </button>
        <span
          class="diwali-promo-spark diwali-promo-spark-one"
          aria-hidden="true"
          >✦</span
        >
        <span
          class="diwali-promo-spark diwali-promo-spark-two"
          aria-hidden="true"
          >✧</span
        >
      </div>
    </div> -->
    <div class="col-span-12 md:col-span-4 h-full">
      <div class="diwali-promo-tile">
        <!-- Fireworks launching from the bottom -->
        <div class="diwali-fireworks" aria-hidden="true">
          <div class="fw" style="--x: 18%; --h: 190px; --d: 0s; --c: #eab83e">
            <b class="fw-rocket"></b>
            <span class="fw-burst"
              ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
              ><i></i><i></i><i></i
            ></span>
          </div>
          <div class="fw" style="--x: 50%; --h: 240px; --d: 1.1s; --c: #fff1be">
            <b class="fw-rocket"></b>
            <span class="fw-burst"
              ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
              ><i></i><i></i><i></i
            ></span>
          </div>
          <div class="fw" style="--x: 82%; --h: 200px; --d: 2.2s; --c: #ff8fa3">
            <b class="fw-rocket"></b>
            <span class="fw-burst"
              ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
              ><i></i><i></i><i></i
            ></span>
          </div>
        </div>

        <span class="diwali-lamp-sparkle">
          <span class="diwali-lamp-glow" aria-hidden="true"></span>
          <span class="diwali-promo-lamp" aria-hidden="true">🪔</span>

          <!-- Cracker sparks bursting around the lamp -->
          <span class="diwali-sparks" aria-hidden="true">
            <i></i><i></i><i></i><i></i><i></i><i></i> <i></i><i></i><i></i
            ><i></i><i></i><i></i>
          </span>
        </span>

        <span class="diwali-promo-kicker">A LITTLE MORE JOY</span>
        <h2>Celebrate Diwali<br />with a little extra sparkle</h2>
        <p>Festive finds and wonderful deals, all in one place.</p>
        <button type="button" (click)="discountProductList()">
          Shop Diwali deals
        </button>

        <span
          class="diwali-promo-spark diwali-promo-spark-one"
          aria-hidden="true"
          >✦</span
        >
        <span
          class="diwali-promo-spark diwali-promo-spark-two"
          aria-hidden="true"
          >✧</span
        >
      </div>
    </div>
    <div
      class="col-span-12 md:col-span-4 border p-4 rounded-3xl bg-[peachpuff] flex flex-col h-full"
    >
      <h1 class="text-xl font-bold mx-3 my-5 flex justify-between">
        Discount On Fashion
        <span
          class="flex underline cursor-pointer hover:text-[#79273a]"
          (click)="discountOnFashionProductList()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="spo h-7 w-7 mx-1 rounded-full"
            fill="white"
            viewBox="0 0 512 512"
          >
            <path
              d="M0 256c0 70.68 28.66 134.7 74.98 181.02C121.3 483.34 185.32 512 256 512c70.69 0 134.7-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256c0-70.69-28.66-134.7-74.98-181.02C390.7 28.66 326.69 0 256 0 185.32 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256zm231.67-109.04L340.7 256 231.67 365.04l-40.52-40.51 68.51-68.52-68.52-68.52 40.53-40.53zM101.01 410.99c-39.66-39.66-64.2-94.47-64.2-154.99 0-60.53 24.54-115.33 64.2-154.99 39.66-39.66 94.47-64.2 154.99-64.2 60.53 0 115.33 24.54 154.99 64.2 39.66 39.66 64.2 94.46 64.2 154.99 0 60.53-24.54 115.33-64.2 154.99-39.66 39.66-94.46 64.2-154.99 64.2-60.52 0-115.33-24.54-154.99-64.2z"
            />
          </svg>
        </span>
      </h1>
      <div class="grid grid-cols-2 gap-3 flex-grow">
        <ng-container *ngIf="fashionLoaded">
          <div
            *ngFor="let item of discountOnFashionProducts"
            class="border p-2 rounded-xl shadow-sm hover:shadow-md transition bg-white h-fit"
          >
            <img
              [src]="productImageUrl + item?.images[0]"
              [alt]="item?.productDetails?.productName || 'Product image'"
              class="w-full h-28 object-contain rounded-md cursor-pointer"
              (click)="productDetails(item)"
            />
            <p
              class="text-center font-semibold text-gray-800 mt-2 text-sm cursor-pointer line-clamp-2"
              (click)="productDetails(item)"
            >
              {{ item.productDetails?.productName }}
            </p>
            <div class="flex items-center gap-2 justify-center mt-2">
              <span
                class="px-3 py-1 bg-[#79273a] text-white rounded-full text-sm font-semibold shadow"
                >₹{{ item?.priceInventoryShippingInfo?.sellingPrice }}</span
              >
              <span class="text-green-700 font-bold text-sm"
                >{{
                  ((item?.priceInventoryShippingInfo?.MRP -
                    item?.priceInventoryShippingInfo?.sellingPrice) /
                    item?.priceInventoryShippingInfo?.MRP) *
                    100 | number: "1.0-0"
                }}% OFF</span
              >
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div lazyLoad (visible)="loadSponsored()" class="h-1"></div>
  <div lazyLoad (visible)="loadBanner()" class="h-1"></div>
  <div lazyLoad (visible)="loadFashion()" class="h-1"></div>

  <div class="flex justify-center m-4">
    <div
      class="spo lg:w-1/2 xs:w-full xs:m-3 rounded-full p-2 text-center m-auto lg:text-2xl xs:text-lg font-bold text-white shadow-lg shadow-black"
    >
      <h1 class="m-auto text-xl">
        Unbeatable Discounts – Grab Your Favorites Today!
      </h1>
    </div>
  </div>

  <div class="relative">
    <!-- Left Scroll Button -->
    <button
      (click)="scrollLeft()"
      aria-label="Previous slide"
      class="absolute left-3 top-1/2 transform -translate-y-1/2 bg-[#79273a] shadow-md shadow-white p-2 rounded-sm z-10 h-20 w-12"
    >
      <svg
        fill="#ffffff"
        class="icon-left"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#e1dbdb"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M23.505 0c0.271 0 0.549 0.107 0.757 0.316 0.417 0.417 0.417 1.098 0 1.515l-14.258 14.264 14.050 14.050c0.417 0.417 0.417 1.098 0 1.515s-1.098 0.417-1.515 0l-14.807-14.807c-0.417-0.417-0.417-1.098 0-1.515l15.015-15.022c0.208-0.208 0.486-0.316 0.757-0.316z"
          ></path>
        </g>
      </svg>
    </button>

    <div
      #scrollContainer
      class="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory p-4 no-scrollbar"
    >
      <div
        class="overflow rounded overflow-hidden shadow-md max-h-80 shadow-[#79273a] snap-center flex-none w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6 cursor-pointer"
        *ngFor="let product of discountedProducts"
      >
        <div (click)="getProductById(product._id)">
          <div class="shadow-lg border-2 sm:h-1/2 min-h-72 rounded-lg bg-white">
            <p
              *ngIf="product?.currentPromotion?.isActive === true"
              class="bg-red-600 text-white rounded-r-lg w-1/2 text-xs animate-pulse rounded-tl-lg px-1"
            >
              FastiveDeals On
            </p>
            <!-- Image with loading state -->
            <div class="h-52 p-2 flex items-center justify-center relative">
              <img
                [src]="productImageUrl + product.images[0]"
                [alt]="product.productDetails.productName"
                priority
                (load)="onImageLoad(product._id)"
                width="3780"
                height="1890"
                class="object-cover w-full h-full mx-auto transition-opacity duration-300"
                [ngClass]="{
                  'opacity-0': loadingStates[product._id],
                  'opacity-100': !loadingStates[product._id],
                }"
              />
              <!-- Blurred placeholder while loading -->
              <!-- <div *ngIf="loadingStates[product._id]" class="absolute inset-0 flex items-center justify-center">
              <div class="bg-blue-300 w-full h-full blur-sm"></div>
            </div> -->

              <div
                *ngIf="loadingStates[product._id]"
                class="absolute inset-0 flex items-center justify-center"
              >
                <img
                  [src]="productImageUrl + product.images[0]"
                  [alt]="product.productDetails.productName"
                  width="200"
                  height="224"
                  class="blur-lg"
                />
              </div>
            </div>

            <div class="flex">
              <span
                class="text-gray-600 font-medium m-auto text-center uppercase text-xs"
                >{{ product?.productDetails.brand }}</span
              >
            </div>
            <p
              class="text-center font-semibold text-sm xs:text-xl border-t border-gray-400 mt-2 line-clamp-1 leading-snug min-h-[1.6em]"
            >
              {{ product?.productDetails?.productName }}
            </p>

            <div class="flex items-center mb-2">
              <del class="text-red-600">
                <p class="text-sm text-red-600 cursor-auto ml-2">
                  ₹{{ product?.priceInventoryShippingInfo?.MRP }}
                </p>
              </del>
              <p class="text-lg font-semibold text-[#79273a] cursor-auto">
                &nbsp;₹{{ product?.priceInventoryShippingInfo.sellingPrice }}
              </p>
              <div
                class="bg-red-700 rounded-sm w-20 ml-2 text-center text-white font-semibold"
              >
                {{
                  ((product?.priceInventoryShippingInfo?.MRP -
                    product?.priceInventoryShippingInfo?.sellingPrice) /
                    product?.priceInventoryShippingInfo?.MRP) *
                    100 | number: "1.0-0"
                }}% off
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div lazyLoad (visible)="loadDiscounted()" class="h-1"></div>
    <!-- Right Scroll Button -->
    <button
      (click)="scrollRight()"
      aria-label="Next slide"
      class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-[#79273a] shadow-md shadow-white p-2 rounded-sm h-20 w-12 z-10"
    >
      <svg
        fill="#ffffff"
        class="icon-right"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#e1dbdb"
        transform="rotate(180)"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M23.505 0c0.271 0 0.549 0.107 0.757 0.316 0.417 0.417 0.417 1.098 0 1.515l-14.258 14.264 14.050 14.050c0.417 0.417 0.417 1.098 0 1.515s-1.098 0.417-1.515 0l-14.807-14.807c-0.417-0.417-0.417-1.098 0-1.515l15.015-15.022c0.208-0.208 0.486-0.316 0.757-0.316z"
          ></path>
        </g>
      </svg>
    </button>
  </div>

  <!-- <div class=" dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8">
  <section class="text-gray-700 dark:text-gray-200">
    <div class="max-w-7xl mx-auto">
      <div
        class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 text-center"
      >
        <div
          class="bg-white dark:bg-gray-800 rounded-lg p-6 hover:scale-105 transition-transform"
        >
          <div class="flex justify-center mb-4">
            <img
              src="./assets/images/secure-payment.png"
              alt="Secure Payment"
              class="w-20 sm:w-24"
            />
          </div>
          <h2 class="text-lg sm:text-xl font-semibold">Secure Payment</h2>
        </div>

        <div
          class="bg-white dark:bg-gray-800 rounded-lg p-6 hover:scale-105 transition-transform"
        >
          <div class="flex justify-center mb-4">
            <img
              src="./assets/images/delivery.png"
              alt="Free Delivery"
              class="w-20 sm:w-24"
            />
          </div>
          <h2 class="text-lg sm:text-xl font-semibold">Free Delivery</h2>
        </div>

        <div
          class="bg-white dark:bg-gray-800 rounded-lg p-6 hover:scale-105 transition-transform"
        >
          <div class="flex justify-center mb-4">
            <img
              src="./assets/images/cod.png"
              alt="Pay on Delivery"
              class="w-20 sm:w-24"
            />
          </div>
          <h2 class="text-lg sm:text-xl font-semibold">Pay On Delivery</h2>
        </div>

        <div
          class="bg-white dark:bg-gray-800 rounded-lg p-6 hover:scale-105 transition-transform"
        >
          <div class="flex justify-center mb-4">
            <img
              src="./assets/images/customer-support.png"
              alt="Support"
              class="w-20 sm:w-24"
            />
          </div>
          <h2 class="text-lg sm:text-xl font-semibold">Support 24/7</h2>
        </div>
      </div>
    </div>
  </section>
</div> -->

  <section class="product-section diwali-collection">
    <div class="section-header">
      <h2>Top Quality Picks For You</h2>
    </div>

    <!-- Marquee starts -->
    <!-- <div class="marquee">
    <div class="marquee-track product-grid" style="display: flex !important">
      <ng-container class="" *ngIf="topQualityLoaded">
        <div
          class="product-card w-56"
          *ngFor="let product of topQualityProducts | slice:0:6"
        >
          <span class="badge">Top Quality</span>

          <div class="image-wrapper">
            <img
              [src]="productImageUrl + product.images[0]"
              alt="product"
              class="object-contain w-full h-full"
            />
          </div>

          <div class="card-body">
            <h3 class="line-clamp-1">
              {{ product.productDetails.productName }}
            </h3>

            <div class="rating">⭐ {{ product.averageRating || 4.5 }}</div>

            <div class="price">
              price ₹{{ product.priceInventoryShippingInfo.sellingPrice }}
            </div>

            <button class="cart-btn" (click)="addToCartFromList(product)">
              Add to Cart
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div> -->

    <div
      class="marquee-container overflow-hidden whitespace-nowrap relative bg-gray-50 py-4"
    >
      <div class="marquee-track flex w-max">
        <ng-container *ngIf="topQualityLoaded">
          <div
            class="product-card w-64 inline-block mx-4 whitespace-normal"
            *ngFor="let product of topQualityProducts | slice: 0 : 6"
          >
            <div
              (click)="getProductById(product._id)"
              class="bg-white rounded-2xl shadow-md cursor-pointer border p-4 relative"
            >
              <span
                class="absolute top-2 left-2 bg-yellow-400 text-[10px] font-bold px-2 py-1 rounded-full uppercase z-10"
              >
                Top Quality
              </span>

              <div class="h-40 w-full flex items-center justify-center">
                <img
                  [src]="productImageUrl + product.images[0]"
                  alt="product"
                  class="object-contain h-full w-full"
                />
              </div>

              <div class="mt-4">
                <h3 class="font-bold text-gray-800 line-clamp-1">
                  {{ product.productDetails.productName }}
                </h3>
                <div class="text-yellow-500 text-sm my-1">
                  ⭐ {{ product.averageRating }}
                </div>
                <div class="font-bold text-[#79273a] text-lg">
                  ₹{{ product.priceInventoryShippingInfo.sellingPrice }}
                </div>
                <button
                  (click)="addToCartFromList(product)"
                  class="w-full mt-3 bg-[#79273a] text-white py-2 rounded-xl hover:bg-[#641e30] transition-colors"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="topQualityLoaded">
          <div
            class="product-card w-64 inline-block mx-4 whitespace-normal"
            *ngFor="let product of topQualityProducts"
          >
            <div
              (click)="getProductById(product._id)"
              class="bg-white rounded-2xl shadow-md cursor-pointer border p-4 relative"
            >
              <span
                class="absolute top-2 left-2 bg-yellow-400 text-[10px] font-bold px-2 py-1 rounded-full uppercase z-10"
              >
                Top Quality
              </span>
              <div class="h-40 w-full flex items-center justify-center">
                <img
                  [src]="productImageUrl + product.images[0]"
                  alt="product"
                  class="object-contain h-full w-full"
                />
              </div>
              <div class="mt-4">
                <h3 class="font-bold text-gray-800 line-clamp-1">
                  {{ product.productDetails.productName }}
                </h3>
                <div class="text-yellow-500 text-sm my-1">
                  ⭐ {{ product.averageRating }}
                </div>
                <div class="font-bold text-[#79273a] text-lg">
                  ₹{{ product.priceInventoryShippingInfo.sellingPrice }}
                </div>
                <button
                  (click)="addToCartFromList(product)"
                  class="w-full mt-3 bg-[#79273a] text-white py-2 rounded-xl hover:bg-[#641e30] transition-colors"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- Marquee ends -->

    <div lazyLoad (visible)="loadTopQuality()" class="h-1"></div>
  </section>

  <div class="mt-9 lg:mx-5 xs:mx-2 overflow-hidden diwali-rated">
    <h1 class="text-xl font-bold mx-5 my-5 flex justify-between">
      Highly Rated & Loved

      <span
        class="flex underline cursor-pointer hover:text-[#79273a]"
        (click)="bestSellarProductList()"
      >
        <!-- Hide "See More" text on small screens -->
        <span class="hidden xs:inline"> See More </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="spo h-7 w-7 mx-1 rounded-full"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision"
          image-rendering="optimizeQuality"
          fill="white"
          fill-rule="evenodd"
          clip-rule="evenodd"
          viewBox="0 0 512 512"
        >
          <path
            fill-rule="nonzero"
            d="M0 256c0 70.68 28.66 134.7 74.98 181.02C121.3 483.34 185.32 512 256 512c70.69 0 134.7-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256c0-70.69-28.66-134.7-74.98-181.02C390.7 28.66 326.69 0 256 0 185.32 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256zm231.67-109.04L340.7 256 231.67 365.04l-40.52-40.51 68.51-68.52-68.52-68.52 40.53-40.53zM101.01 410.99c-39.66-39.66-64.2-94.47-64.2-154.99 0-60.53 24.54-115.33 64.2-154.99 39.66-39.66 94.47-64.2 154.99-64.2 60.53 0 115.33 24.54 154.99 64.2 39.66 39.66 64.2 94.46 64.2 154.99 0 60.53-24.54 115.33-64.2 154.99-39.66 39.66-94.46 64.2-154.99 64.2-60.52 0-115.33-24.54-154.99-64.2z"
          />
        </svg>
      </span>
    </h1>

    <!-- <swiper-container
    #swiperContainer
    pagination="false"
    navigation="true"
    indicator="true"
    Autoplay="true"
    class="flex"
  >
    <swiper-slide
      class="m-auto flex justify-center min-h-96 max-h-96 cursor-pointer"
      *ngFor="let product of  bestSellingProducts" 
    >
      <div 
        class="card shadow-lg border-2 border-[#79273a] rounded-lg w-56"
        (click)="getProductById(product._id)"
      >
        <h1 class="w-full bg-[#79273a] text-center font-semibold text-white">
          {{
            ((product?.priceInventoryShippingInfo?.MRP -
              product?.priceInventoryShippingInfo?.sellingPrice) /
              product?.priceInventoryShippingInfo?.MRP) *
              100 | number : "1.0-0"
          }}% off
        </h1>
        <img
          [src]="productImageUrl + product.images[0]"
          alt="{{ product.productDetails.productName }}"
          class="h-56 w-36 m-5 object-contain m-auto"
        />
        <span class="text-gray-600 font-medium mr-3 uppercase text-xs">{{
          product?.productDetails.brand
        }}</span>
        <p class="font-normal text-lg line-clamp-3">
          {{ product.productDetails.productName }}
        </p>

        <div class="flex items-center mb-2">
          <p class="text-sm text-red-600 m-auto">
            <span class="line-through"
              >₹{{ product?.priceInventoryShippingInfo?.MRP }}</span
            >
            <span class="text-lg no-underline font-semibold text-[#79273a]">
              &nbsp;₹{{ product?.priceInventoryShippingInfo.sellingPrice }}
            </span>
          </p>
        </div>
      </div>
    </swiper-slide>
  </swiper-container> -->

    <swiper-container
      #swiperContainer
      init="false"
      pagination="false"
      navigation="true"
      indicator="true"
      Autoplay="true"
      class="flex"
    >
      <ng-container
        *ngIf="(bestSellingProducts?.length ?? 0) > 0; else fallbackList"
      >
        <swiper-slide
          class="m-auto flex justify-center min-h-96 max-h-96 cursor-pointer"
          *ngFor="let product of bestSellingProducts | slice: 0 : 8"
        >
          <div
            class="card shadow-lg border-2 border-[#79273a] rounded-lg w-56"
            (click)="getProductById(product._id)"
          >
            <h1
              class="w-full bg-[#79273a] text-center font-semibold text-white"
            >
              {{
                ((product?.priceInventoryShippingInfo?.MRP -
                  product?.priceInventoryShippingInfo?.sellingPrice) /
                  product?.priceInventoryShippingInfo?.MRP) *
                  100 | number: "1.0-0"
              }}% off
            </h1>

            <!-- Image with loading state -->
            <div class="h-56 p-2 flex items-center justify-center relative">
              <img
                [src]="productImageUrl + product.images[0]"
                [alt]="product.productDetails.productName"
                width="200"
                height="224"
                priority
                (load)="onImageLoad(product._id)"
                class="object-contain mx-auto transition-opacity duration-300 max-h-56"
                [ngClass]="{
                  'opacity-0': loadingStates[product._id],
                  'opacity-100': !loadingStates[product._id],
                }"
              />
              <!-- Blurred placeholder while loading -->
              <!-- <div *ngIf="loadingStates[product._id]" class="absolute inset-0 flex items-center justify-center">
              <div class="bg-blue-300 w-full h-full blur-sm"></div>
            </div> -->

              <div
                *ngIf="loadingStates[product._id]"
                class="absolute inset-0 flex items-center justify-center"
              >
                <img
                  [src]="productImageUrl + product.images[0]"
                  [alt]="product.productDetails.productName"
                  width="200"
                  height="224"
                  class="blur-lg"
                />
              </div>
            </div>

            <span class="text-gray-600 font-medium mr-3 uppercase text-xs">{{
              product?.productDetails.brand
            }}</span>
            <p class="font-normal text-lg line-clamp-2">
              {{ product.productDetails.productName }}
            </p>
            <div class="flex items-center">
              <p class="text-sm text-red-600 m-auto">
                <span class="line-through"
                  >₹{{ product?.priceInventoryShippingInfo?.MRP }}</span
                >
                <span class="text-lg no-underline font-semibold text-[#79273a]">
                  &nbsp;₹{{ product?.priceInventoryShippingInfo.sellingPrice }}
                </span>
              </p>
            </div>
          </div>
        </swiper-slide>
      </ng-container>

      <!-- Fallback Swiper Slide -->
      <ng-template #fallbackList>
        <swiper-slide
          class="m-auto flex justify-center min-h-96 max-h-96 cursor-pointer"
          *ngFor="let product of bestSellarProduct"
        >
          <div
            class="card shadow-lg border-2 border-[#79273a] rounded-lg w-56"
            (click)="getProductById(product._id)"
          >
            <h1
              class="w-full bg-[#79273a] text-center font-semibold text-white"
            >
              {{
                ((product?.priceInventoryShippingInfo?.MRP -
                  product?.priceInventoryShippingInfo?.sellingPrice) /
                  product?.priceInventoryShippingInfo?.MRP) *
                  100 | number: "1.0-0"
              }}% off
            </h1>
            <img
              [src]="productImageUrl + product.images[0]"
              alt="{{ product.productDetails.productName }}"
              class="h-56 w-36 m-5 object-contain m-auto"
            />
            <span class="text-gray-600 font-medium mr-3 uppercase text-xs">{{
              product?.productDetails.brand
            }}</span>
            <p class="font-normal text-lg line-clamp-3">
              {{ product.productDetails.productName }}
            </p>
            <div class="flex items-center mb-2">
              <p class="text-sm text-red-600 m-auto">
                <span class="line-through"
                  >₹{{ product?.priceInventoryShippingInfo?.MRP }}</span
                >
                <span class="text-lg no-underline font-semibold text-[#79273a]">
                  &nbsp;₹{{ product?.priceInventoryShippingInfo.sellingPrice }}
                </span>
              </p>
            </div>
          </div>
        </swiper-slide>
      </ng-template>
    </swiper-container>
  </div>

  <div lazyLoad (visible)="loadBestSelling()" class="h-1"></div>
  <!-- <section class="px-4" (click)="discountProductList()">
  <div
    class="spo p-6 sm:p-10 rounded-2xl w-full text-white flex items-center justify-between max-w-2xl mx-auto mt-4"
  >
    <div class="flex flex-col gap-6">
      <div class="">
        <span class="text-gray-200">Discount on every Product</span>
        <br />
        <span class="text-gray-200 text-4xl text-white font-semibold"
          >Pay online via UPI or Cards and save ₹40!</span
        >
      </div>
      <a
        href=""
        target="_blank"
        rel="noreferrer"
        class="text-black bg-white hover:bg-gray-50 px-4 py-2 rounded-lg w-fit ease duration-300 flex gap-1 items-center group"
      >
        <span>Buy now</span>
        <svg
          data-v-e660a7a7=""
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-hidden="true"
          role="img"
          class="group-hover:translate-x-1 transition-transform ease duration-200"
          width="1em"
          height="1em"
          viewBox="0 0 256 256"
        >
          <path
            fill="currentColor"
            d="m221.66 133.66l-72 72a8 8 0 0 1-11.32-11.32L196.69 136H40a8 8 0 0 1 0-16h156.69l-58.35-58.34a8 8 0 0 1 11.32-11.32l72 72a8 8 0 0 1 0 11.32Z"
          ></path>
        </svg>
      </a>
    </div>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-20 h-20 text-gray-100"
        viewBox="0 0 15 15"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M4.5 0A2.5 2.5 0 0 0 2 2.5v.286c0 .448.133.865.362 1.214H1.5A1.5 1.5 0 0 0 0 5.5v1A1.5 1.5 0 0 0 1.5 8H7V4h1v4h5.5A1.5 1.5 0 0 0 15 6.5v-1A1.5 1.5 0 0 0 13.5 4h-.862c.229-.349.362-.766.362-1.214V2.5A2.5 2.5 0 0 0 10.5 0c-1.273 0-2.388.68-3 1.696A3.498 3.498 0 0 0 4.5 0ZM8 4h2.786C11.456 4 12 3.456 12 2.786V2.5A1.5 1.5 0 0 0 10.5 1A2.5 2.5 0 0 0 8 3.5V4ZM7 4H4.214C3.544 4 3 3.456 3 2.786V2.5A1.5 1.5 0 0 1 4.5 1A2.5 2.5 0 0 1 7 3.5V4Z"
          clip-rule="evenodd"
        ></path>
        <path
          fill="currentColor"
          d="M7 9H1v3.5A2.5 2.5 0 0 0 3.5 15H7V9Zm1 6h3.5a2.5 2.5 0 0 0 2.5-2.5V9H8v6Z"
        ></path>
      </svg>
    </div>
  </div>
</section> -->

  <div class="mt-5"></div>

  <!-- Second Row Of clothing-->
</main>
